import { render, staticRenderFns } from "./ApprovedContent.vue?vue&type=template&id=ecad0a7c&"
import script from "./ApprovedContent.vue?vue&type=script&lang=js&"
export * from "./ApprovedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports